import { useEffect, useMemo, useState } from 'react';

import { useTranslation } from '@webtrader/core/i18n';

export const useCountdown = (targetDate: number) => {
  const countDownDate = new Date(targetDate).getTime();
  const diff = countDownDate - new Date().getTime();
  const [countDown, setCountDown] = useState(diff);

  useEffect(() => {
    const interval = setInterval(() => {
      if (diff <= 0) {
        clearInterval(interval);
      } else {
        setCountDown(diff);
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [diff]);

  return targetDate ? getReturnValues(countDown) : [0, 0];
};

const getReturnValues = (countDown: number) => {
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

  return [minutes, seconds];
};

export const useLoginAttemptText = (timer: number[]) => {
  const { t } = useTranslation();

  const displayLiner = useMemo(() => {
    return t('Too many failed login attempts. Please try again in {{minutes}} {{seconds}}.', {
      minutes:
        timer[0] < 2 ? t('{{period}} minute', { period: timer[0] }) : t('{{period}} minutes', { period: timer[0] }),
      seconds:
        timer[1] < 2 ? t('{{period}} second', { period: timer[1] }) : t('{{period}} seconds', { period: timer[1] })
    });
  }, [t, timer]);

  return displayLiner;
};
